var CryptoJS = require("crypto-js");
const { buildStaffMemberInfoHtml } = require("./_staff_member_info");

$(function () {
    setupStaffLogout();

    if ($(".js-modal-login-staff").length > 0) {
        loginStaffForm();
    }

    if ($(".js-search-member-data").length > 0) {
        const search = $(".js-search-member-data");
        const searchCode = search.data("code");
        const searchTitle = search.data("title");
        const searchTitleSearch = search.data("title-search");
        const searchUrl = search.data("url");
        const rcUrl = search.data("url-rc");
        const headphoneUrl = search.data("headphone-url");
        const searchBtn = $(".js-search-btn");
        const searchList = $(".js-search-list");
        const reimbursementOptions = search.data("reimbursementOptions") || {};
        const attendanceTypeOptions = search.data("attendanceTypeOptions") || {};

        let staffRcModal = new bootstrap.Modal(
            document.getElementById("staffMemberModal"),
            {
                keyboard: false,
            }
        );
        const headphoneModalElement = document.getElementById("staffHeadphoneModal");
        const staffHeadphoneModal = headphoneModalElement
            ? new bootstrap.Modal(headphoneModalElement, { keyboard: false })
            : null;

        function setHeadphoneMessage(type, message) {
            const messageBox = $(".js-search-headphone-message");

            messageBox.text(message);
            messageBox.removeClass("d-none is-success is-error");

            if (!message) {
                messageBox.addClass("d-none");
                return;
            }

            messageBox.addClass(type === "success" ? "is-success" : "is-error");
        }

        function bindHeadphoneButtons() {
            $(".js-headphone-popup").click(function () {
                if (!staffHeadphoneModal) return;

                const btn = $(this);

                $("#staffHeadphoneModal").attr("data-member-rc-id", btn.data("member-rc-id"));
                $("#staffHeadphoneModal").attr("data-source-hash", btn.data("hash"));
                $("#staffHeadphoneModal").attr("data-source-employee-id", btn.data("employee-id"));
                $(".js-headphone-member-name").text(btn.data("name"));
                $(".js-search-headphone-input").val(btn.data("headphone-info") || "");
                $(".js-save-search-headphone").prop("disabled", false);
                setHeadphoneMessage("", "");

                staffHeadphoneModal.show();
            });
        }

        searchBtn.click(function () {
            let q = search.find("#q").val();
            console.log(q);

            searchList.html("");
            $(".js-modal-footer").addClass("d-none");

            if (!(q.length > 2)) {
                return;
            }

            searchList.html(`
                <div class="text-center py-4">
                    <i class="fas fa-spinner fa-spin fa-2x"></i>
                </div>
            `);

            $.ajax({
                url: `${searchUrl}?q=${q}&code=${searchCode}`,
                type: "GET",
                dataType: "html",
                success: function (response) {
                    searchList.html(response);

                    $(".js-rc-popup").click(function () {
                        const btn = $(this);
                        const hash = btn.data("hash");
                        const employee_id = btn.data("employee-id");
                        const name = btn.data("name");
                        const rc = btn.data("rc");
                        const rc_name = btn.data("rc-name");
                        const yesBtn = $(".js-rc-yes");

                        yesBtn.attr("data-hash", hash);
                        yesBtn.attr("data-employee-id", employee_id);
                        yesBtn.attr("data-name", name);
                        yesBtn.attr("data-rc", rc);
                        yesBtn.attr("data-rc-name", rc_name);

                        $(".js-modal-footer").addClass("d-none");
                        $(".js-modal-confirm").removeClass("d-none");

                        const memberInfoHtml = buildStaffMemberInfoHtml(
                            {
                                first_name: btn.attr("data-first-name"),
                                last_name: btn.attr("data-last-name"),
                                email: btn.attr("data-email"),
                                business_unit: btn.attr("data-business-unit"),
                                specify_business_unit: btn.attr("data-specify-business-unit"),
                                attendance_type: btn.attr("data-attendance-type"),
                                reimbursement_type: btn.attr("data-reimbursement-type"),
                                headphone_info: btn.attr("data-headphone-info"),
                            },
                            {
                                attendanceTypeOptions,
                                reimbursementOptions,
                            }
                        );

                        $(".js-modal-staff-rc-html").html(`
                            <div class="pt-2 text-start">
                                ${memberInfoHtml}
                                <div class="staff-member-info__confirm text-center mt-3 mb-2 h5 text-black">
                                    ยืนยัน ${name}<br>${searchTitleSearch} หรือไม่?
                                </div>
                            </div>
                        `);

                        staffRcModal.show();
                    });

                    bindHeadphoneButtons();
                },
            });
        });

        $(".js-rc-yes").click(function () {
            rcStaff($(this), rcUrl, staffRcModal);
        });

        $(".js-save-search-headphone").click(function () {
            if (!staffHeadphoneModal) return;

            const saveBtn = $(this);
            const headphoneInput = $(".js-search-headphone-input");
            const headphoneData = headphoneInput.val().trim();
            const headphoneInfoValue = headphoneData || null;
            const memberRcId = $("#staffHeadphoneModal").attr("data-member-rc-id");

            if (!memberRcId) {
                setHeadphoneMessage("error", "ไม่พบข้อมูล Check-in กรุณา Check-in ก่อน");
                return;
            }

            saveBtn.prop("disabled", true);
            setHeadphoneMessage("", "");

            axios
                .post(headphoneUrl, {
                    member_rc_id: memberRcId,
                    headphone_info: headphoneInfoValue,
                })
                .then(function () {
                    const hash = $("#staffHeadphoneModal").attr("data-source-hash");
                    const employeeId = $("#staffHeadphoneModal").attr("data-source-employee-id");
                    const headphoneBtn = $(
                        `.js-headphone-popup[data-hash="${hash}"][data-employee-id="${employeeId}"]`
                    );
                    const row = headphoneBtn.closest("tr");

                    headphoneBtn.data("headphone-info", headphoneData);
                    headphoneBtn.attr("data-headphone-info", headphoneData);

                    if (headphoneInfoValue) {
                        row.find(".js-headphone-info").removeClass("d-none");
                        row.find(".js-headphone-info-value").text(headphoneData);
                    } else {
                        row.find(".js-headphone-info").addClass("d-none");
                        row.find(".js-headphone-info-value").text("");
                    }

                    setHeadphoneMessage(
                        "success",
                        headphoneInfoValue
                            ? `บันทึกข้อมูลหูฟัง "${headphoneData}" เรียบร้อยแล้ว`
                            : "ล้างข้อมูลหูฟังเรียบร้อยแล้ว"
                    );

                    window.setTimeout(function () {
                        staffHeadphoneModal.hide();
                    }, 1200);
                })
                .catch(function () {
                    setHeadphoneMessage("error", "บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
                    saveBtn.prop("disabled", false);
                });
        });
    }
});

function clearStaffSession() {
    localStorage.removeItem("scg_staff_login");
    localStorage.removeItem("scg_staff_booth");
    localStorage.removeItem("mea_staff_login");
}

function setupStaffLogout() {
    const logoutBtn = $(".js-staff-logout");

    if (logoutBtn.length === 0) return;

    const staffExpiredAt = parseInt(localStorage.getItem("scg_staff_login"), 10);

    if (staffExpiredAt && Date.now() < staffExpiredAt) {
        logoutBtn.removeClass("d-none");
    }

    logoutBtn.on("click", function () {
        if (!confirm("คุณต้องการออกจากระบบ Staff หรือไม่?")) {
            return;
        }

        clearStaffSession();
        window.location.reload();
    });
}

function rcStaff(btn, url, rcModal) {
    $(".js-modal-footer").addClass("d-none");
    $(".js-modal-loading").removeClass("d-none");

    let hash = btn.attr("data-hash");
    let employee_id = btn.attr("data-employee-id");
    let name = btn.attr("data-name");
    let rc = btn.attr("data-rc");
    let rcName = btn.attr("data-rc-name");
    let token = $('input[name="_token"]').val();

    var formData = new FormData();
    formData.append("hash", hash);
    formData.append("employee_id", employee_id);
    formData.append("rc", rc);
    formData.append("_token", token);

    axios.post(url, formData).then(function (response) {
        let data = response.data;

        console.log(data);
        if (data.status == "error") {
            const errorMessage =
                typeof data.messages === "string"
                    ? data.messages
                    : data.messages && data.messages.redeem
                    ? data.messages.redeem[0]
                    : data.messages
                    ? Object.values(data.messages).flat()[0]
                    : "เกิดข้อผิดพลาด";

            window.rduNotify(errorMessage || "เกิดข้อผิดพลาด", "warning");

            return;
        } else {
            console.log(name);
            console.log(data.status_point);
            if (data.status_souvenir_full == true) {
                $(`.js-rc-popup`).attr("disabled", "disabled");

                $(".js-modal-staff-rc-html").html(`
                    <div class="pt-3">
                        <div class="mb-4">
                            <i class="fas fa-exclamation-circle fa-4x text-danger" style="font-size: 5rem;"></i>
                        </div>
                        <div class="mb-4 h4 text-black">
                            สิทธิ์เต็มแล้ว
                        </div>
                    </div>
                `);
            } else if (data.status_point == true) {
                $(
                    `.js-rc-popup[data-rc="${rc}"][data-hash="${hash}"][data-employee-id="${employee_id}"]`
                )
                    .attr("disabled", "disabled")
                    .text("ใช้สิทธิ์แล้ว");
                $(
                    `.js-headphone-popup[data-rc="${rc}"][data-hash="${hash}"][data-employee-id="${employee_id}"]`
                )
                    .removeAttr("disabled")
                    .attr("data-member-rc-id", data.member_rc_id || "")
                    .data("member-rc-id", data.member_rc_id || "")
                    .attr("data-headphone-info", data.headphone_info || "")
                    .data("headphone-info", data.headphone_info || "");
                $(".js-member-rc-count").text(
                    parseInt($(".js-member-rc-count").text()) + 1
                );
                $(".js-modal-staff-rc-html").html(`
                        <div class="pt-3">
                            <div class="mb-4">
                                <i class="fas fa-check-circle fa-4x text-success" style="font-size: 5rem;"></i>
                            </div>
                            <div class="mb-4 h4 text-black">
                                ${name}<br>
                                ลงทะเบียน "${rcName}" เรียบร้อย
                            </div>
                        </div>
                    `);
            } else {
                $(".js-modal-staff-rc-html").html(`
                    <div class="pt-3">
                        <div class="mb-4">
                            <i class="fas fa-exclamation-triangle fa-4x text-warning" style="font-size: 5rem;"></i>
                        </div>
                        <div class="mb-4 h4 text-black">
                            ${name}<br>
                            ลงทะเบียน "${rcName}" แล้ว (ซ้ำ)
                        </div>
                    </div>
                `);
            }

            $(".js-modal-footer").addClass("d-none");
            $(".js-modal-close").removeClass("d-none");

            rcModal.show();
        }
    });
}

function loginStaffForm() {
    const staff = parseInt(localStorage.getItem("scg_staff_login"), 10);

    if (staff && Date.now() < staff) return;

    clearStaffSession();

    let loginStaffModal = new bootstrap.Modal(document.getElementById("loginStaffModal"), {
        keyboard: false,
    });

    loginStaffModal.show();

    // staff1–staff20 / password: Rdu1234 (MD5)
    const staffPassMd5 = "9f00080a6e74db1f87e827ef1b544707";
    const users = {
        "4d7d719ac0cf3d78ea8a94701913fe47": { pass: staffPassMd5, booth: "all" }, // staff1
        "8bc01711b8163ec3f2aa0688d12cdf3b": { pass: staffPassMd5, booth: "all" }, // staff2
        "8f03660f569ce4023dddaea0bf560d74": { pass: staffPassMd5, booth: "all" }, // staff3
        "f5895009da33053ae2fa2e3dfb93e84a": { pass: staffPassMd5, booth: "all" }, // staff4
        "cf2aeef74dc08f4d2e7067e98bf34e6e": { pass: staffPassMd5, booth: "all" }, // staff5
        "40767ff0e9b02e391f80576ebf3ca9c8": { pass: staffPassMd5, booth: "all" }, // staff6
        "99c746833d7c5f028009e385d623ffed": { pass: staffPassMd5, booth: "all" }, // staff7
        "bd259424543a4736ee6eef2b997738b4": { pass: staffPassMd5, booth: "all" }, // staff8
        "57d06536a350c518b0e74f5f27129bfa": { pass: staffPassMd5, booth: "all" }, // staff9
        "2d1ef8331155e01a4fdaa31defedffd6": { pass: staffPassMd5, booth: "all" }, // staff10
        "d0b9340ca3ad671889e16c8de617ba89": { pass: staffPassMd5, booth: "all" }, // staff11
        "3a9964a8664e778994cb38864954d167": { pass: staffPassMd5, booth: "all" }, // staff12
        "d02b9a29b4fd24e30a5ea45c7ee2844c": { pass: staffPassMd5, booth: "all" }, // staff13
        "faacd7d490bdd2c1b7cb4a7b89c98f0e": { pass: staffPassMd5, booth: "all" }, // staff14
        "6886cd2ce3a59781a0de62584847448f": { pass: staffPassMd5, booth: "all" }, // staff15
        "6541d7c6037e590cd64ec10112550b04": { pass: staffPassMd5, booth: "all" }, // staff16
        "bad7f61e9ecc5a42146c4cd7077427d0": { pass: staffPassMd5, booth: "all" }, // staff17
        "09dc5846553dbaa8f7c81b6b1e1028b6": { pass: staffPassMd5, booth: "all" }, // staff18
        "f20f7bf5ca5dfb313343cd236ee54cbb": { pass: staffPassMd5, booth: "all" }, // staff19
        "4adefb88490d6e2e67907e003a1d6d72": { pass: staffPassMd5, booth: "all" }, // staff20
    };

    const login = $(".js-modal-login-staff");
    const form = login.find("#loginStaffForm");
    const normalizeStaffCredential = (value) => String(value ?? "").trim().replace(/[\u200B-\u200D\uFEFF]/g, "");

    $.validator.addMethod("username_rule", function (value) {
        const userMd5 = CryptoJS.MD5(normalizeStaffCredential(value)).toString();
        return users.hasOwnProperty(userMd5);
    }, "Username is incorrect.");

    $.validator.addMethod("pass_rule", function (value, element) {
        const username = normalizeStaffCredential(form.find("[name='username']").val());
        const userMd5 = CryptoJS.MD5(username).toString();
        const passMd5 = CryptoJS.MD5(normalizeStaffCredential(value)).toString();

        if (users[userMd5] && users[userMd5].pass === passMd5) {
            return true;
        }
        return false;
    }, "Password is incorrect.");

    form.validate({
        rules: {
            username: {
                required: true,
                username_rule: true,
            },
            password: {
                required: true,
                minlength: 4,
                pass_rule: true,
            },
        },
        messages: {
            username: {
                required: "กรุณากรอกชื่อผู้ใช้",
            },
            password: {
                required: "กรุณากรอกรหัสผ่าน",
                minlength: "รหัสผ่านควรมีอย่างน้อย {0} ตัวอักษร",
            },
        },
        errorClass: "-error",
        errorElement: "div",
        errorLabelContainer: ".error-message",
        submitHandler: function () {
            const username = normalizeStaffCredential(form.find("[name='username']").val());
            const userMd5 = CryptoJS.MD5(username).toString();
            const booth = users[userMd5].booth;

            const t = new Date().getTime() + 86400000;

            localStorage.setItem("scg_staff_login", t);
            localStorage.setItem("scg_staff_booth", booth); // 👈 เก็บ booth

            window.location.reload(1);
        },
    });
}